import imageCompression from 'browser-image-compression';

/**
 * Compresses an image file before uploading to Firebase
 * @param {File} imageFile - The original image file
 * @returns {Promise<File>} - The compressed image file
 */
export const compressImage = async (imageFile) => {
  if (!imageFile.type.startsWith('image/')) {
    return imageFile;
  }

  const options = {
    maxSizeMB: 0.3,          
    maxWidthOrHeight: 1200,  
    useWebWorker: true,      
  };

  try {
    console.log(`Original Size: ${(imageFile.size / 1024 / 1024).toFixed(2)} MB`);
    const compressedFile = await imageCompression(imageFile, options);
    console.log(`Compressed Size: ${(compressedFile.size / 1024 / 1024).toFixed(2)} MB`);
    
    return compressedFile;
  } catch (error) {
    console.error("❌ Image compression failed, returning original:", error);
    return imageFile; 
  }
};

/**
 * Validates a video file size before allowing upload
 * @param {File} videoFile - The video file
 * @param {number} maxMB - Maximum allowed size in Megabytes (default 15MB)
 * @returns {boolean} - True if it passes, false if it's too big
 */
export const isValidVideoSize = (videoFile, maxMB = 15) => {
  if (!videoFile.type.startsWith('video/')) {
    return true; 
  }

  const fileSizeMB = videoFile.size / 1024 / 1024;
  if (fileSizeMB > maxMB) {
    alert(`This video is too large (${fileSizeMB.toFixed(1)}MB). Please choose a video under ${maxMB}MB.`);
    return false;
  }
  
  return true;
};      

// 🟢 Google Cloud Vision AI Scanner (Updated to accept a File object)
export const analyzeImageSafety = async (file) => {
    // 1. Convert the File to a pure Base64 string automatically
    const getBase64 = (f) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(f);
        reader.onload = () => resolve(reader.result.split(',')[1]);
        reader.onerror = error => reject(error);
    });

    try {
        const base64Data = await getBase64(file);
        
        // 2. Put your Google Cloud API Key right here!
        const API_KEY = "AIzaSyA95ygmME1kz5WjSAGzYQtM3pNWbVOowkY"; 
        
        const response = await fetch(`https://vision.googleapis.com/v1/images:annotate?key=${API_KEY}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                requests: [{
                    image: { content: base64Data },
                    features: [{ type: "SAFE_SEARCH_DETECTION" }]
                }]
            })
        });
        
        const data = await response.json();
        const safeSearch = data.responses[0]?.safeSearchAnnotation;
        
        if (!safeSearch) return false;

        // 🚨 Flag if Adult (Porn) or Violence (Blood/Gore) is LIKELY or VERY_LIKELY
        const badCategories = ['LIKELY', 'VERY_LIKELY'];
        if (badCategories.includes(safeSearch.adult) || badCategories.includes(safeSearch.violence)) {
            console.warn("🚨 AI Blocked Image:", safeSearch);
            return true; // IT IS DANGEROUS -> Triggers the Hard Stop
        }
        
        return false; // IT IS SAFE -> Upload proceeds normally
        
    } catch (error) {
        console.error("Vision API Error:", error);
        return false; // If offline/error, allow upload to prevent blocking good users
    }
};